var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.isPatient)?_c('h1',[_vm._v(_vm._s(_vm.$t('dashboard.titles.main')))]):_vm._e(),(_vm.isPatient)?_c('h2',[_vm._v(_vm._s(_vm.today))]):_vm._e(),_c(_vm.componentName,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }